<template>
  <v-container fluid class="px-0 mx-0">
    <v-data-table
      disable-sort
      :mobile-breakpoint="0"
      :headers="headers"
      :items="itemsWithSno"
      class="elevation-1 mt-10 ms-2"
      :options.sync="options"
      :loading="loading"
      :server-items-length="totalItemsCount"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
    >
      <template #[`item.nameEn`]="{ item }">{{ item.nameEn }}</template>
      <template #[`item.nameAr`]="{ item }">{{ item.nameAr }}</template>
      <template #[`item.id`]="{ item }">{{ item.itemId }}</template>
      <template #item.brandName="{ item }">
        <span v-if="item.brand">
          {{ item.brand.nameEn }}
        </span>
      </template>

      <template #item.vendor="{ item }">
        <span v-if="item.vendor">
          {{ item.vendor.companyNameEn }}
        </span>
      </template>

      <template #[`item.unit`]="{ item }">
        {{ getUnitName(item.quantityUnit) }}
      </template>
      <template #[`item.conversionUnit`]="{ item }">
        {{ getConversionUnit(item.quantityUnit) }}
      </template>
      <template #[`item.conversionValue`]="{ item }">
        {{ getConversionValue(item.quantityUnit) }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <app-master-update-form
            v-if="hasRole(AdminUserPermissions.MASTER_DATA_EDIT)"
            :ingredientInfo="item"
          ></app-master-update-form>
          <StockMasterDelete
            v-if="hasRole(AdminUserPermissions.MASTER_DATA_DELETE)"
            :ingredient="item"
          />
        </v-row>
        <!-- <v-icon small class="me-2" @click="editItem()">mdi-pencil</v-icon>
      <v-icon small @click="deleteItem()">mdi-delete</v-icon>-->
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import StockMasterUpdateForm from "../components/StockMasterUpdateForm";
import StockMasterDelete from "../components/StockMasterDelete";
export default {
  components: {
    "app-master-update-form": StockMasterUpdateForm,
    StockMasterDelete,
  },
  props: {
    searchKey: {
      type: String,
    },
  },
  created() {
    this.getAllUnits();
  },

  data: () => ({
    dialog: false,
    loading: true,
    options: {
      itemsPerPage: 25,
      page: 1,
    },
    variables: {
      limit: 25,
      skip: 0,
    },
    headers: [
      { text: "Item ID", value: "id", width: 100 },
      { text: "Item Name (English)", value: "nameEn" },
      { text: "Item Name (Arabic)", value: "nameAr" },
      { text: "Brand Name", value: "brandName", width: 100, sortable: false },
      { text: "Vendor", value: "vendor", width: 100, sortable: false },
      { text: "Unit", value: "unit", sortable: false },
      { text: "Conversion Unit", value: "conversionUnit", width: 100, sortable: false },
      { text: "Conversion Scale", value: "conversionValue", width: 200, sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    stockList: [],
    totalItemsCount: 25,
    unitList: [],
  }),
  computed: {
    itemsWithSno() {
      return this.stockList.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
  },
  apollo: {
    getAllIngredients() {
      return {
        query: require("../api/getAllIngredients.graphql"),
        variables: this.variables,
        result({ data, loading }) {
          this.loading = loading;
          this.stockList = data.getAllIngredients.ingredients;
          this.totalItemsCount = data.getAllIngredients.totalCount;
          console.log(this.stockList.length);
        },
      };
    },
  },
  watch: {
    searchKey: {
      handler() {
        this.$apollo.queries.getAllIngredients.refetch({
          limit: 25,
          skip: 0,
          searchKey: this.searchKey,
        });
      },
    },
    options: {
      handler() {
        (this.variables.limit = this.options.itemsPerPage),
          (this.variables.skip =
            this.options.page * this.options.itemsPerPage - this.options.itemsPerPage);
        this.$apollo.queries.getAllIngredients.refetch({
          limit: this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 500,
          skip: this.options.page * this.options.itemsPerPage - this.options.itemsPerPage,
        });
      },
      deep: true,
    },
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    getAllUnits() {
      this.$apollo
        .watchQuery({
          query: require("../api/getAllUnits.graphql"),
          variables: this.variables,
        })
        .refetch({})
        .then((data) => {
          if (data.data) {
            this.unitList = data.data.getAllUnits.units;
          }
        });
    },
    getUnitName(id) {
      if (id) {
        let data = this.unitList.find((x) => x._id == id);
        if (data) {
          return data.name;
        }
      }
      return "--";
    },
    getConversionUnit(id) {
      if (id) {
        let data = this.unitList.find((x) => x._id == id);
        if (data) {
          return data.conversionUnit;
        }
      }
      return "--";
    },
    getConversionValue(id) {
      if (id) {
        let data = this.unitList.find((x) => x._id == id);
        if (data) {
          return data.conversionValue;
        }
      }
      return "--";
    },
    editItem() {
      this.dialog = true;
    },

    deleteItem() {},

    close() {
      this.dialog = false;
    },
  },
};
</script>
